import React, { useState, useEffect } from 'react';
import HobbiesSection from '../components/About/HobbiesSection';
import ListeningCarousel from '../components/ListeningCarousel/ListeningCarousel';
import GitHubCalendar from 'react-github-calendar';
import SocialSection from '../components/About/SocialSection';
import TidbitsSection from '../components/About/TidbitsSection';
import './AboutPage.css';

export default function AboutPage() {
  const [repos, setRepos] = useState([]);
  useEffect(() => {
    fetch('https://api.github.com/users/sitzmana/repos?sort=updated&per_page=5')
      .then(res => res.json())
      .then(data => setRepos(data))
      .catch(err => console.error('GitHub repos error:', err));
  }, []);

  return (
    <section className="about-page">
      <h1>About Me</h1>
      <p>
        Hi, I’m Alex Sitzman — a cloud engineer and a lifelong learner
      </p>
      <p>
        Curiosity drives everything I do. I’m always exploring new technologies, refining my skills, and sharing what I learn along the way. Whether it’s diving into Kubernetes internals, streamlining workflows, or experimenting with home automation, I enjoy turning complex challenges into clean, efficient solutions.
      </p>


      {/* GitHub Activity */}
      <section className="git-section">
        <h2>GitHub</h2>
        <h3>Username: sitzmana</h3>
        <GitHubCalendar username="sitzmana" />

        <div className="repo-section">

          <h3>Latest Repositories</h3>
          {repos.length ? (
            <div className="repo-list">
              {repos.map(repo => (
                <a
                  key={repo.id}
                  href={repo.html_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="repo-card"
                >
                  <h4>{repo.name}</h4>
                  {repo.description && <p>{repo.description}</p>}
                  <div className="repo-meta">
                    {repo.language && <span>{repo.language}</span>}
                    <span>⭐ {repo.stargazers_count}</span>
                  </div>
                </a>
              ))}
            </div>
          ) : (
            <p>Loading repositories...</p>
          )}
        </div>
      </section>
      {/* Hobbies */}
      {<HobbiesSection />}
      <TidbitsSection/>
      {/* Music */}
      <section className="music-section">

<ListeningCarousel />
</section>

      {/* Social Links */}
      <SocialSection />
    </section>
  );
}